module.exports = __webpack_public_path__ + "quick-load.png?ab89b2ad19bbcb2181d725d9eae5a7b3";